import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { sumInsuredamount,QuickQuoteHealth,PostQuoteHealth } from "../../Redux/actions/NumHealth";
import { 
  Button, 
  Form,
  Radio,
  message
} from 'antd/lib';
import axiosInHealth from "../../Redux/axios/AxiosInHealth";
export default function CoverEditHeath({setisModalCover}) {
    const dispatch = useDispatch();
    const Healthnum = useSelector((state) => state?.healthdetail?.healthnum);
  const QuotePost = useSelector((state) => state?.healthdetail?.QuickQuotePost);
    const [loading, setLoading] = useState(false)
    const [product, setproduct] = useState([]);

    useEffect(() => {
        dispatch(sumInsuredamount())
        .then((res) => {
            console.log(res)
          setproduct(res);
        })
        .catch((err) => {
          console.log(err)
        });
      }, [dispatch]);
    const onChange = (e) => {
      console.log('radio checked', e.target.value);
      // setValue(e.target.value);
    };
    const onFinish = (values) => {
        console.log('product values',values)
        const UpdatePlan = {
          ...QuotePost,
          suminsured : values?.suminsured_cover,
        }
        setLoading(true)
        axiosInHealth
        .post(`v1/health_insurances/${Healthnum?.health_insurance_id}/quick_quotes`, UpdatePlan)
          .then((res) => {
            if (res.status === 200) {
              const data = res?.data?.data
            console.log(data)
              // const errData = data?.filter(item => ("status" in item && item.status === "failed"));
              // dispatch(Err_quotes(errData));
              const filteredData = data?.filter(item => ("status" in item && item.status === "success"));
              const updatedData = filteredData?.map(item => ({
                ...item,
                selected: false
              }));
              console.log(updatedData)
              dispatch(QuickQuoteHealth(updatedData));
              dispatch(PostQuoteHealth(UpdatePlan))
              setLoading(false)
              setisModalCover(false)
            }
          })
          .catch((err) => {
            console.log(err.response.data.error);
            setLoading(false)
            message.error(err.response.data.error);
          });
      }; 
  return (
    <>
       <Form
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        >
            <p className="border-bottom mb-0"
             style={{fontSize: "13px", paddingBottom:"10px"}}>Select a cover range to view plans that offer the desired Sum Insured.</p>
          <Form.Item
          name="suminsured_cover"
        className="cvEditSec"
          rules={[
            {
              required: true,
              message: 'Please select Policy Type',
            },
          ]}
          initialValue={QuotePost?.suminsured}
          >
            <Radio.Group
              className="py-3 px-3 pb-0 bg-white ant-radio-layout prev-prod-sec-health"
              onChange={onChange}
              >
                {product.map((e,i) => (
                  <Radio
                  key={i} value={e}>
                    {e === "300000" ? 'Upto 3 Lakhs': 
                    e === "500000" ? 'More than 3 Lakhs, Upto 5Lakhs': 
                    e === '750000' ? 'More than 5 Lakhs, Upto 7.5 Lakhs':
                    e === '1000000' ? 'More than 7.5 Lakhs, Upto 10 Lakhs':
                    e === '1500000' ? 'More than 10 Lakhs, Upto 15 Lakhs': 
                    e === '2000000' ? 'More than 15 Lakhs, Upto 20 Lakhs':
                    e === '2500000' ? 'More than 20 Lakhs, Upto 25 Lakhs':
                    e === '5000000'? 'More than 25 Lakhs, Upto 50 Lakhs': 
                    e === '7500000' ? 'More than 50 Lakhs, Upto 75 Lakhs':
                    e === '10000000' ? 'More than 70 Lakhs, Upto 1 Crore': ''}
                    {console.log(e)}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{textAlign: "center"}}>
                <Button type="primary" 
                htmlType="submit"
                className="update-qut-button"
                loading={loading}
                >Update</Button>
            </Form.Item>
        </Form>
    </>
  );
}
